import { Field, ObjectType } from "type-graphql";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import BacklogItem from "./backlog-item";

/** A lane in the backlog */
@Entity('backlog-lane')
@ObjectType()
export default class BacklogLane {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** The title of the backlog item */
    @Column('varchar')
    @Field(() => String)
    public title: string

    /** The backlog items */
    @OneToMany(() => BacklogItem, item => item.lane, {
        nullable: true
    })
    @Field(() => [BacklogItem], {
        nullable: true
    })
    public items: null | BacklogItem[]

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date
}